<template>
  <div class="card looking">
    <div class="card-top">
      <p>
        <router-link
          :to="{ name: 'profile', params: { id: looking.user.id } }"
          class="body-color"
        >
          <avatar :user="looking.user" />
          {{ looking.user.first_name }} {{ looking.user.last_name }}
        </router-link>

        is looking to buy
      </p>

      <div
        v-if="userData"
        class="star-and-menu"
      >
        <star :post="looking" />
        <item-menu :looking="looking" />
      </div>
    </div>

    <div class="main stretched">
      <span>Looking to buy</span>
      <span>{{ looking.title }}</span>

      <div class="description">
        <pre>{{ looking.description }}</pre>
      </div>
    </div>

    <div class="stats-and-message">
      <div class="stats">
        <button
          type="button"
          class="btn btn-transparent"
          @click="showComments = !showComments"
        >
          {{ pluralize(looking.total_comments, 'comment') }}
        </button>

        <total-likes
          :comment="false"
          :likes="looking.likes"
          :total-likes="looking.total_likes"
        />

        <span>{{ dateFromNow(looking.created) }}</span>
      </div>

      <button
        v-if="userData"
        type="button"
        class="btn btn-primary btn-sm"
        @click="message"
      >
        Message
      </button>
    </div>

    <hr class="stretched">

    <div class="actions">
      <template v-if="userData">
        <like :looking="looking" />

        <button
          type="button"
          class="comment-button btn btn-transparent"
          @click="comment"
        >
          <comment-outline-icon />
          <span class="small">Comment</span>
        </button>
      </template>

      <share />
    </div>

    <comments
      v-show="showComments"
      ref="comments"
      object-type="looking"
      :object-id="looking.id"
      :comments="looking.comments"
    />
  </div>
</template>

<script>
import Avatar from '@/components/Avatar.vue';
import Comments from '@/components/Comments.vue';
import ItemMenu from '@/components/ItemMenu.vue';
import Like from '@/components/Like.vue';
import Share from '@/components/Share.vue';
import Star from '@/components/Star.vue';
import TotalLikes from '@/components/TotalLikes.vue';

export default {
  components: {
    Avatar,
    Comments,
    ItemMenu,
    Like,
    Share,
    Star,
    TotalLikes,
  },
  props: {
    looking: {
      type: Object,
      required: true,
    },
    detail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showComments: this.detail,
    };
  },
  methods: {
    comment() {
      if (this.showComments) {
        const commentTextarea = this.$refs.comments.$el.querySelector('.js-comment-textarea');

        if (this.isElementInViewport(commentTextarea)) {
          commentTextarea.focus();
        } else {
          commentTextarea.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });

          setTimeout(() => {
            commentTextarea.focus();
          }, 1000);
        }
      } else {
        this.showComments = true;
      }
    },
    message() {
      this.$router.push({
        name: 'message_listing',
        params: { id: this.looking.id, user: this.looking.user.id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .main {
    display: block;
    padding: 1.5rem;
    color: #fff;
    background-color: var(--blue-light);
    text-align: center;

    span {
      display: block;
      font-size: 1.25rem;
    }
  }

  .stats-and-message {
    display: grid;
    grid-gap: 0.5rem;
    grid-template-columns: 1fr auto;
    align-items: center;
    margin: 0.5rem 0;
  }
</style>
